import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form clearfix tile_count" };
const _hoisted_2 = { class: "col-xs-12 col-sm-12 col-md-3 tile_stats_count" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-desktop" }),
    /*#__PURE__*/ _createTextVNode(" Total Systems\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_5 = { class: "count clearfix" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-3 tile_stats_count" };
const _hoisted_7 = { class: "clearfix green" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle" }),
    /*#__PURE__*/ _createTextVNode(" Healthy\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_9 = { class: "count clearfix" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-3 tile_stats_count" };
const _hoisted_11 = { class: "clearfix orange" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-question-circle" }),
    /*#__PURE__*/ _createTextVNode(" Warned\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_13 = { class: "count clearfix" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-3 tile_stats_count" };
const _hoisted_15 = { class: "clearfix red" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-warning" }),
    /*#__PURE__*/ _createTextVNode(" Critical\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_17 = { class: "count clearfix" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.numberOfSystems), 1 /* TEXT */)
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.numberOfHealthySystems), 1 /* TEXT */)
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.numberOfWarningSystems), 1 /* TEXT */)
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.numberOfCriticalSystems), 1 /* TEXT */)
            ])
        ])
    ]));
}
